import { Context } from "@nuxt/types/app";

import { SUCCESS, ERROR } from "@/shared/constants/services.constant";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function transformResponseMessage(
    type: string,
    customErrorMessage: string,
    dataName: string,
    APIErrorResponseMessage: string,
  ): string {
    if (type === SUCCESS) {
      return `<b>Well done!</b> ${customErrorMessage} ${dataName}`;
    }
    if (type === ERROR) {
      return `<b>Error!</b> ${customErrorMessage} ${dataName}. ${APIErrorResponseMessage}`;
    }
    return `<b>Error!</b> ${customErrorMessage} ${dataName}. ${APIErrorResponseMessage}`;
  }

  return {
    transformResponseMessage,
  };
}
